export class TabsComponent {
    constructor(_tabId, callback, isAnimate = true) {
        this._tabId = _tabId;
        this.callback = callback;
        this.isAnimate = isAnimate;
        this.animationTime = 300;
    }
    onInit() {
        const containerTab = document.getElementById(this._tabId);
        const containerBtns = containerTab === null || containerTab === void 0 ? void 0 : containerTab.querySelector('.tab-btns');
        const containerContents = containerTab === null || containerTab === void 0 ? void 0 : containerTab.querySelector('.tab-contents');
        if (!containerBtns || !containerContents)
            return;
        // Set first tab-btn as selected and unhide the first tab
        this.selectTabByIndex(containerBtns, containerContents, 0);
        Array.from(containerBtns.children).forEach(tabButton => tabButton.addEventListener("click", (e) => {
            this.selectTab(containerBtns, containerContents, tabButton);
        }, { passive: true }));
    }
    selectTabByIndex(containerBtns, containerContents, index) {
        const selected = containerBtns.children[index];
        this.selectTab(containerBtns, containerContents, selected);
    }
    selectTab(containerBtns, containerContents, selected) {
        var _a;
        Array.from(containerBtns.children).forEach((tabBtn) => tabBtn.classList.toggle("selected", false));
        Array.from(containerContents.children).forEach((tabContent) => tabContent.classList.add("hidden"));
        selected.classList.toggle('selected', true);
        const idSelected = selected.getAttribute('data-content-id');
        const content = containerContents.querySelector(`#${idSelected}`);
        console.log(content);
        if (this.isAnimate) {
            content && (content.style.opacity = '0');
            content && setTimeout(() => {
                content.style.opacity = '1';
            }, this.animationTime);
        }
        (_a = content === null || content === void 0 ? void 0 : content.classList) === null || _a === void 0 ? void 0 : _a.toggle("hidden", false);
        this.callback && this.callback();
    }
}
